import { Component } from "@angular/core";

@Component({
    selector: "evta-auth-block",
    styleUrls: ["./auth-block.component.scss"],
    template: `
    <ng-content></ng-content>
  `,
    standalone: false
})
export class AuthBlockComponent {
}
